export default {"src":"/_next/static/media/0x9879abdea01a879644185341f7af7d8343556b7a.c044dbfa.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};